import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
    Box,
    Button,
    CircularProgress,
    IconButton,
    InputAdornment,
    Paper,
    TextField,
    Typography,
} from "@mui/material";
import axios from "axios";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { REDIRECT_URL } from "../../helper/helper";
import { colorPrimaryDark } from "../../rsc/colors";
import { ReactComponent as PempemLogo } from "../../rsc/logo.svg";
import { t } from "i18next";

type State = {
    loading: boolean
    isSuccess?: boolean
    error?: string
}

function ChangePassword() {
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const [showNew, setShowNew] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);

    const [param] = useSearchParams();
    const email = param.get("email");
    const oob = param.get("oob");

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        if (newPassword !== confirmPassword) {
            setState({
                loading: false,
                error: "Password Not Matching"
            });
            return;
        } else {
            updatePassword()
        }
    };

    const [state, setState] = useState<State>({
        loading: false,
        isSuccess: undefined
    })

    function updatePassword() {
        if (confirmPassword.length < 6) {
            setState({
                loading: false,
                isSuccess: undefined,
                error: "Need at least 6 characters"
            })
        } else {
            const data = {
                "oob": oob,
                "email": decodeURIComponent(email ?? ""),
                "password": confirmPassword
            }

            setState({
                loading: true,
                isSuccess: undefined
            })

            axios.post(`${process.env.REACT_APP_BASE_URL_PUBLIC}/auth/welcome/resetPassword`, data, {
                withCredentials: false,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    "x-app-name": "welcome",
                    "x-app-id": process.env.REACT_APP_APP_ID,
                }
            }).then(() => {
                setState({
                    loading: false,
                    isSuccess: true
                })
                setTimeout(() => {
                    window.location.href = REDIRECT_URL;
                }, 2000)
            }).catch(e => {
                console.log(e)
                setState({
                    loading: false,
                    isSuccess: false,
                    error: e.response.data.message ?? e.message
                })
            })
        }
    }

    return (
        <Box
            minHeight="100vh"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            bgcolor="#f5f5f5"
            p={2}
        >
            <Paper elevation={3} sx={{ p: 4, width: "100%", display: 'flex', flexDirection: 'column', maxWidth: 400, alignItems: 'center', justifyContent: 'center' }}>
                <Typography variant="h5" gutterBottom>
                    {
                        state.isSuccess === true ? t("congrats_password_changed") : t("change_password")
                    }
                </Typography>
                <PempemLogo fill={colorPrimaryDark} />
                {
                    state.error === "EXPIRED" ?
                        <Typography variant="h5" sx={{marginTop:'10px'}} gutterBottom>
                            {t("link_expired")}
                        </Typography>
                        :
                        <form onSubmit={handleSubmit}>
                            <TextField
                                label={t("new_password")}
                                type={showNew ? "text" : "password"}
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                fullWidth
                                margin="normal"
                                required
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={() => setShowNew(!showNew)} edge="end">
                                                {showNew ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />

                            <TextField
                                label={t("confirm_password")}
                                type={showConfirm ? "text" : "password"}
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                fullWidth
                                margin="normal"
                                required
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={() => setShowConfirm(!showConfirm)} edge="end">
                                                {showConfirm ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            {
                                state.error &&
                                <Typography variant="body2" color="success.main" mt={2} textAlign="end" style={{ color: 'red' }}>
                                    {state.error}
                                </Typography>
                            }


                            <Button
                                disabled={state.isSuccess === true}
                                type="submit"
                                variant="contained"
                                color="primary"
                                fullWidth
                                sx={{ mt: 2 }}
                            >
                                {
                                    state.loading ?
                                        <CircularProgress
                                            size={32}
                                            sx={{
                                                color: 'white'
                                            }}
                                        />
                                        :
                                        <>{t("update_password")}</>
                                }
                            </Button>
                        </form>
                }
            </Paper>
        </Box>
    );
}

export default ChangePassword;
